// useUpdateMode — detecta si el funnel se abrió en modo "actualizar plan".
//
// Activado por los query params ?update=<petId>&sub=<subscriptionId>.
// Cuando están presentes:
//   - El formulario se pre-rellena con los datos del perro (hidratación en App.tsx).
//   - Un banner amber avisa al usuario de que está editando un plan existente.
//   - Step13 NO crea un nuevo checkout; llama a updatePetPlan() y muestra
//     pantalla de éxito en lugar de redirigir a Shopify/PrestaShop.
//
// Persiste los IDs en sessionStorage para que el modo sobreviva
// navegación interna entre steps (la URL del funnel es la misma SPA).
// Al finalizar el update, redirigimos a /mi-cuenta sin los params, lo que
// elimina el flag en la siguiente carga.

const SESSION_KEY_PET = 'myl_update_pet_id';
const SESSION_KEY_SUB = 'myl_update_sub_id';

export interface UpdateContext {
  isUpdateMode: boolean;
  petId: string | null;
  subscriptionId: string | null;
}

export function useUpdateMode(): UpdateContext {
  if (typeof window === 'undefined') {
    return { isUpdateMode: false, petId: null, subscriptionId: null };
  }

  const params = new URLSearchParams(window.location.search);
  const petIdFromUrl = params.get('update');
  const subIdFromUrl = params.get('sub');

  if (petIdFromUrl && subIdFromUrl && petIdFromUrl.length > 0 && subIdFromUrl.length > 0) {
    try {
      sessionStorage.setItem(SESSION_KEY_PET, petIdFromUrl);
      sessionStorage.setItem(SESSION_KEY_SUB, subIdFromUrl);
    } catch {
      // sessionStorage bloqueado (modo privado extremo) — seguimos con URL params
    }
    return { isUpdateMode: true, petId: petIdFromUrl, subscriptionId: subIdFromUrl };
  }

  // Si no hay URL params, intentar recuperar de sessionStorage (navegación interna)
  try {
    const petId = sessionStorage.getItem(SESSION_KEY_PET);
    const subscriptionId = sessionStorage.getItem(SESSION_KEY_SUB);
    if (petId && subscriptionId) {
      return { isUpdateMode: true, petId, subscriptionId };
    }
  } catch {
    // sessionStorage bloqueado — no hay update mode
  }

  return { isUpdateMode: false, petId: null, subscriptionId: null };
}

/** Limpia el estado de update mode de sessionStorage. Llamar tras confirmar el update. */
export function clearUpdateMode(): void {
  try {
    sessionStorage.removeItem(SESSION_KEY_PET);
    sessionStorage.removeItem(SESSION_KEY_SUB);
  } catch {
    // noop
  }
}
